import { render, staticRenderFns } from "./DashedGreyLine.vue?vue&type=template&id=71ccd83a&scoped=true"
var script = {}
import style0 from "./DashedGreyLine.vue?vue&type=style&index=0&id=71ccd83a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ccd83a",
  null
  
)

export default component.exports